// Русские строки приложения — source of truth (app.md §9, ui-kit.md §6).
//
// Строки самих компонентов дизайн-системы живут в packages/ui-kit/src/i18n/;
// здесь только доменные строки app. Хардкод видимого текста в компонентах запрещён.

export const ru = {
  'app.name': 'Рестомаркер',
  'app.start.placeholder': 'Каркас приложения. Экраны появятся в задачах T-001…T-007.',
  'network.offline': 'Нет сети — работаем офлайн',
  'network.syncing': 'Синхронизация…',
  'network.queued': 'Ждёт отправки',
  'network.queued.title': 'Что значит «ждёт отправки»',
  'network.queuedHint':
    'Печать всегда работает на самом устройстве — и без связи тоже. Напечатанные этикетки сохраняются здесь и уезжают на сервер сами, как только связь появится. Число — сколько их пока не уехало. Повторять печать не нужно: этикетка уже напечатана и не потеряется. Пока она не уехала, менеджер в мониторинге её не видит.',
  'network.queued.flushNow': 'Отправить сейчас',
  'network.syncError.retry': 'Ошибка отправки — нажмите, чтобы повторить',
  // Кто и куда — прямо в тексте: «накопленное уедет после входа» владелец не понял
  // (2026-09-27: «кто уедет? куда уедет?»).
  'network.needsLogin':
    'Вход истёк — войдите заново. Сделанное на этом устройстве сохранено и отправится на сервер после входа.',

  // --- Обновление приложения (T-034) --------------------------------------
  // Бандл уже скачан и проверен; нажатие перезагружает интерфейс. «Скачана» и «Установить»,
  // а не «доступна новая версия интерфейса» и «Обновить»: владелец (2026-09-27) не понял,
  // что делает кнопка, — а так же называют обновление приложений в самом телефоне.
  'update.available': 'Скачана новая версия приложения',
  'update.apply': 'Установить',
  'update.applying': 'Установка…',

  // --- Аутентификация ------------------------------------------------------
  'auth.login.title': 'Вход',
  'auth.login.email': 'Email',
  'auth.login.password': 'Пароль',
  'auth.login.submit': 'Войти',
  // Почему человек оказался на входе (B-034). Раньше его выкидывало молча, и после
  // повторного входа выкидывало снова — непонятно за что и непонятно, что делать.
  'auth.sessionEnded.revoked':
    'Вход сброшен: в кабинете изменили доступ (PIN, пароль или роль). Войдите заново — сделанное на этом устройстве сохранено.',
  'auth.sessionEnded.expired':
    'Вход истёк — войдите заново. Сделанное на этом устройстве сохранено.',
  'auth.invite.title': 'Установка пароля',
  'auth.invite.checking': 'Проверяем ссылку…',
  'auth.invite.password': 'Новый пароль',
  'auth.invite.passwordHint': 'Не короче 8 символов, минимум одна цифра.',
  'auth.invite.passwordConfirm': 'Повторите пароль',
  'auth.invite.submit': 'Установить пароль',
  'auth.invite.deadTitle': 'Ссылка недействительна',
  'auth.invite.deadExpired': 'Срок действия ссылки истёк. Запросите новую у администратора.',
  'auth.invite.deadUsed':
    'Ссылка уже использована. Если пароль установлен, войдите обычным способом.',
  'auth.invite.toLogin': 'Перейти ко входу',
  // Формулировки ведут к разным действиям: к администратору либо к повторному входу.
  'auth.error.invalidCredentials': 'Неверный email или пароль.',
  'auth.error.blocked': 'Доступ закрыт. Обратитесь к администратору.',
  'auth.error.sessionRevoked': 'Доступ отозван. Обратитесь к администратору.',
  'auth.error.sessionExpired': 'Сессия истекла. Войдите заново.',
  'auth.error.generic': 'Не удалось выполнить вход.',
  'auth.error.network': 'Нет связи с сервером. Проверьте сеть.',
  'auth.forbidden.title': 'Доступ к разделу закрыт',
  'auth.notFound.title': 'Такой страницы нет',
  // Чек-лист настройки на дашборде (Фаза 5). Новый менеджер/админ иначе приземляется
  // на пустой экран без подсказки, что делать. Карточка уходит, когда всё готово.
  'onboarding.checklist.titleLocation': 'Настройка точки',
  'onboarding.checklist.titleNetwork': 'Настройка сети',
  'onboarding.checklist.lede': 'Несколько шагов до готовности — отметятся сами, когда выполните.',
  'onboarding.checklist.step.menu': 'Заполните меню точки',
  'onboarding.checklist.step.menuHint':
    'Добавьте продукты из справочника сети или заведите свои — по ним печатаются этикетки.',
  'onboarding.checklist.step.staff': 'Добавьте сотрудников',
  'onboarding.checklist.step.staffHint':
    'Без них некому печатать: каждый входит своим логином и паролем.',
  'onboarding.checklist.step.location': 'Создайте первую точку',
  'onboarding.checklist.step.locationHint': 'Меню приедет в неё копией каталога сети.',
  'onboarding.checklist.step.managers': 'Пригласите менеджеров точек',
  'onboarding.checklist.step.managersHint': 'Они дочистят меню и заведут поваров на своих точках.',
  'onboarding.checklist.go': 'Открыть',

  // --- Адрес сервера (Фаза 4) --------------------------------------------
  // Первый экран на новом планшете: одна сборка приложения работает с сервером
  // любой сети, адрес вводит тот, кто настраивает планшет.
  'setup.title': 'Адрес сервера',
  'setup.lede': 'Введите адрес сервера вашей сети — его даёт администратор.',
  'setup.field': 'Адрес сервера',
  'setup.placeholder': 'https://…',
  'setup.submit': 'Проверить и сохранить',
  'setup.checking': 'Проверяю…',
  'setup.error.unreachable': 'Сервер не отвечает. Проверьте адрес и соединение.',
  'setup.error.notRestomarker': 'По этому адресу отвечает не сервер Рестомаркера.',
  'setup.error.serverError': 'Сервер ответил ошибкой {code}. Попробуйте позже.',

  'auth.notFound.description':
    'Адрес неверный или раздел удалён. Проверьте ссылку или вернитесь на главный экран.',
  'auth.forbidden.action': 'На главную',
  'auth.forbidden.description':
    'У вашей роли нет прав на этот экран. Раздел существует — он просто не ваш.',

  // --- Журнал печати -------------------------------------------------------
  'journal.pageTitle': 'Журнал печати',
  'journal.subtitle': 'Полная лента печатей точки. Здесь разбирают, что произошло.',
  'journal.column.time': 'Время',
  'journal.column.employee': 'Сотрудник',
  'journal.column.product': 'Продукт',
  'journal.column.mode': 'Режим',
  'journal.column.expires': 'Истекает',
  'journal.column.status': 'Статус',
  'journal.status.active': 'Активна',
  'journal.status.expired': 'Просрочено',
  'journal.status.disposed': 'Списана',
  'journal.status.voided': 'Аннулирована',
  'journal.status.replaced': 'Заменена перепечаткой',
  'journal.batch': 'Партия',
  'journal.clockDrift': 'Часы',
  'journal.clockDriftHint':
    'Часы устройства расходились с сервером — время в строке может быть неточным.',
  'journal.filter.status': 'Статус',
  'journal.filter.allStatuses': 'Все статусы',
  'journal.filter.mode': 'Режим',
  'journal.filter.allModes': 'Все режимы',
  'journal.filter.since': 'С даты',
  'journal.filter.until': 'По дату',
  'journal.event.disposed': 'списана',
  'journal.event.voided': 'аннулирована',
  'journal.event.replaced': 'заменена',
  'journal.action.history': 'История',
  'journal.history.title': 'История записи',
  'journal.history.printed': 'Напечатана',
  'journal.history.disposed': 'Списана',
  'journal.history.voided': 'Аннулирована',
  'journal.history.replaced': 'Заменена перепечаткой',
  'journal.history.reprintOf': 'Перепечатка другой записи: срок унаследован от источника',
  'journal.history.unknownActor': 'автор неизвестен',
  'journal.action.void': 'Аннулировать',
  'journal.action.dispose': 'Списать',
  'journal.action.undispose': 'Отменить списание',
  'journal.action.reprint': 'Перепечатать',
  'journal.void.title': 'Аннулировать этикетку?',
  'journal.void.disposePhysical': 'Физическую этикетку утилизируйте.',
  'journal.void.onlyThis': 'Только эту',
  'journal.void.wholeBatch': 'Всю партию',
  'journal.reprint.title': 'Перепечатать этикетку',
  'journal.reprint.description': 'Проверьте состав перед печатью.',
  'journal.reprint.confirm': 'Перепечатать',
  'journal.reprint.inheritNotice':
    'Срок остаётся исходным: перепечатка заменяет носитель, а не продлевает годность.',
  'journal.preview.product': 'Наименование',
  'journal.preview.printedAt': 'Изготовлено',
  'journal.preview.expiresAt': 'Годен до',
  'journal.preview.fifo': 'Номер',
  'journal.emptyTitle': 'Печатей пока не было',
  'journal.emptyDescription':
    'Здесь появятся все этикетки точки — активные, списанные и аннулированные.',

  // --- Персонал ------------------------------------------------------------
  // --- Ответственность за срок годности (T-016) ---
  // Формулировка не юридическая отписка, а факт: ТР ТС 021/2011 и Роспотребнадзор
  // прямо относят установление срока к изготовителю, включая продукцию собственного
  // производства предприятия общепита. Молчание означало бы, что платформа берёт
  // на себя чужую ответственность, а клиент узнаёт об этом при проверке.
  'catalog.shelfLifeDisclaimer':
    'Значения справочные. Срок годности продукции собственного производства ' +
    'устанавливает изготовитель — проверьте их по своим технологическим картам.',

  // --- Мониторинг сроков (T-004) ---
  'monitoring.pageTitle': 'Мониторинг сроков',
  'monitoring.subtitle': 'Что истекает и что уже просрочено, но ещё не выброшено.',
  'monitoring.emptyFiltered': 'Под фильтры ничего не подошло',
  'monitoring.emptyFilteredHint': 'На точке есть заготовки, но ни одна не совпала с отбором.',
  'monitoring.resetFilters': 'Сбросить фильтры',
  'monitoring.filter.status': 'Статус',
  'monitoring.filter.allStatuses': 'Все статусы',
  'monitoring.filter.author': 'Кто печатал',
  'monitoring.filter.allAuthors': 'Все сотрудники',
  'monitoring.location': 'Точка',
  'monitoring.kpi.expired': 'Уже просрочено',
  // Не «за 24 ч»: запас предупреждения пропорционален сроку позиции и упирается
  // в сутки только сверху (`monitoring/shared/status.ts`). Обещать в подписи
  // конкретное число значило бы врать на всех коротких сроках.
  'monitoring.kpi.expiringSoon': 'Скоро истекает',
  'monitoring.kpi.activeNow': 'Активных сейчас',
  'monitoring.kpi.printedToday': 'Напечатано сегодня',
  'monitoring.kpi.printedWeek': 'За неделю',
  'monitoring.column.product': 'Продукт',
  'monitoring.column.fifo': 'Номер',
  'monitoring.column.expires': 'Истекает',
  'monitoring.column.printedBy': 'Кто печатал',
  'monitoring.dispose': 'Списать',
  'monitoring.emptyTitle': 'Активных этикеток нет',
  // Текст описывал печать «с устройства, привязанного к точке» — механизм, удалённый
  // в T-018. Печатает человек своим логином, устройство субъектом не является.
  'monitoring.emptyText':
    'Как только на кухне напечатают этикетку, она появится здесь. ' +
    'Печатает сотрудник под своим логином — устройство для этого настраивать не нужно.',
  'monitoring.emptyAction': 'Устройства точки',
  'monitoring.dispose.title': 'Списать продукт?',
  'monitoring.dispose.confirm': '«{name}» будет отмечен как утилизированный.',
  'monitoring.dispose.submit': 'Списать',
  'monitoring.dispose.undoHint': 'Отменить можно в течение 5 минут.',
  'monitoring.undo.text': '«{name}» списан.',
  'monitoring.void.hint':
    'Аннулировать — если этикетка напечатана по ошибке: её не должно было быть. Физическую этикетку утилизируйте. Отменить аннулирование нельзя.',
  // Кнопка ОТМЕЧАЕТ просроченные, а не списывает их (T-027): списывает всегда футер,
  // и глагол обязан называть то, что произойдёт по тапу, — иначе на экране два
  // разных «списать».
  'monitoring.bulk.button': 'Выбрать просроченные',
  // Ярлык по разрешению сети (T-052) — тоже только отмечает, включая годные.
  'monitoring.bulk.selectAll': 'Выбрать все',
  'monitoring.bulk.freshWarning': 'Годных среди них: {n} — они тоже будут списаны.',
  'monitoring.bulk.title': 'Списать выбранные?',
  'monitoring.bulk.hint':
    'Каждая будет отмечена как утилизированная. Отменить можно в течение 5 минут.',
  'monitoring.bulk.submit': 'Списать',
  // Список в подтверждении редактируемый (решение владельца 2026-10-03).
  'monitoring.bulk.remove': 'Убрать из списка',
  'monitoring.bulk.done': 'Списано: {n}. Продукты утилизируйте физически.',
  'monitoring.bulk.undo': 'Отменить списание',
  'monitoring.undo.action': 'Отменить списание',
  // Футер табло (T-027) — по образцу футера печати: заголовок с числом и подпись,
  // отвечающая на вопрос «что именно я сейчас нажму».
  'monitoring.footer.dispose': 'Списать',
  'monitoring.footer.pick': 'Выберите плитку',
  'monitoring.footer.selected': 'Выбрано: {n}',
  'monitoring.footer.reset': 'Сбросить выбор',
  'monitoring.kitchen.title': 'Что в работе',
  'monitoring.kitchen.noLocation': 'Вам не назначена точка',
  'monitoring.kitchen.noLocationHint':
    'Список показывает заготовки вашей точки. Обратитесь к менеджеру — он назначит её ' +
    'в карточке сотрудника.',
  'monitoring.kitchen.empty': 'Активных этикеток нет',
  'monitoring.kitchen.emptyHint': 'Напечатайте этикетку — она появится в списке.',

  // --- Экран печати (T-002) ---
  'print.search': 'Поиск по названию',
  'print.shelfLifeFilter': 'Категория срока',
  'print.bandFilter': 'Полка срока',
  'print.typeFilter': 'Тип продукта',
  'print.allShelfLives': 'Все',
  'print.categoryEmpty': 'В меню точки нет продуктов с категорией «{name}».',
  'print.categoryEmptyAdd': 'Добавить из каталога',
  'print.categoryEmptyAsk': 'Добавить их может менеджер точки.',
  'print.found': 'Найдено: {n}',
  'print.resetFilters': 'Сбросить',
  'kiosk.logout.title': 'Выйти из аккаунта?',
  'kiosk.logout.description':
    'Очередь неотправленных операций сохранится и уедет, когда вы войдёте снова. Для входа нужен пароль и связь с сервером.',
  'monitoring.kitchen.order': 'Порядок',
  'monitoring.kitchen.orderExpiring': 'Сначала горящие',
  'monitoring.kitchen.orderFresh': 'Недавно добавленные',
  'print.title': 'Печать этикеток',
  // Печать на экран вместо принтера (T-032). Плашка ПОСТОЯННАЯ, не тост: тост
  // исчезнет, а причина останется, и повар решит, что принтер сломался.
  'print.previewOnly':
    'Принтер не подключён — этикетка показана на экране. Подключить: вкладка «Настройка принтера» вверху экрана.',
  'print.failure.title': 'Напечатано {n} из {total}',
  'print.failure.retryRest': 'Повторить остаток',
  'print.failure.unknown': 'Принтер не отвечает.',
  // Д7: принтер точки уже держит другое устройство. Имя — из ответа сервера,
  // а не общее «занято»: повару полезно знать, к кому подойти.
  'print.failure.busy': 'Принтер занят: печатает {holder}. Подождите и повторите.',
  // Без имени: принтер не ответил на вызов. Отсюда не отличить «держит другое
  // устройство» (D6, один принтер на кухню) от «выключен или далеко» — называем все
  // причины, а не угадываем одну (2026-09-26: «занят» показывали, когда принтер
  // держало зависшее подключение этого же телефона).
  'print.failure.busyDevice':
    'Принтер не отвечает: с него печатает другое устройство, он выключен или далеко. Подождите и повторите.',
  // Не прочитался номер или не встала очередь (T-044): IndexedDB устройства отказала.
  'print.failure.storage':
    'Не удалось сохранить печать на устройстве. Повторите; если не помогает — перезапустите приложение',
  'print.waiting.title': 'Ждём принтер…',
  'print.waiting.hint':
    'Он просыпается после простоя или занят другим устройством — это до 2 минут. Печать начнётся сама, нажимать ещё раз не нужно.',
  'print.pickProduct': 'Выберите заготовку в списке',
  'print.filters': 'Фильтры',
  'print.mode.otherModes': 'Другие режимы печати',
  // Видимая подпись на самой кнопке — короткая, полная фраза выше уходит в aria-label.
  // Раньше кнопка была голыми точками без единого слова — тестировщики на пилоте
  // не нашли «Свою этикетку» именно поэтому, нечего было прочитать, только угадать.
  'print.mode.moreLabel': 'Ещё',
  'print.showFound': 'Показать: {n}',
  'print.nothingFound': 'Ничего не найдено',
  'print.nothingFoundHint': 'Сбросьте фильтры или измените запрос.',
  'print.emptyMenu': 'В меню точки пусто',
  'print.emptyMenuHint': 'Позиции добавляет менеджер в кабинете.',
  'print.mode.all': 'Печать этикетки',
  // С числом («Печать · 7 шт») — короче: кнопка в одну строку на телефоне рядом с «Кол-во».
  'print.mode.allShort': 'Печать',
  // Раньше здесь стояли три отдельных режима — «Своё название», «Своя дата
  // окончания», «Своя дата начала». T-022 (2026-08-14) схлопнул их в один диалог
  // «Своя этикетка» с тремя необязательными полями: повару была нужна комбинация
  // (своё имя И свой срок сразу), а три взаимоисключающих пункта меню её не давали.
  'print.mode.free': 'Своя этикетка',
  'print.custom.optionalHint': 'Поле можно пропустить — печать не заблокируется.',
  'print.custom.requiredHint': 'Дата обязательна: от неё считается срок годности.',
  'print.custom.freeHint':
    'Заполните только то, что отличается: пустые поля возьмутся из справочника и момента печати.',
  'print.custom.endBeforeStart': 'Дата окончания должна быть позже даты изготовления.',
  // Проверки ДО печати (B-036): к синку наклейка уже на полке, и отказ сервера увёл бы
  // печать в ошибку, а продукт — из мониторинга.
  'print.custom.startInFuture': 'Дата изготовления ещё не наступила — проверьте дату и время.',
  'print.custom.alreadyExpired':
    'С такой датой изготовления у «{name}» срок уже истёк — этикетка вышла бы просроченной.',
  'print.custom.endInPast': 'Дата окончания уже прошла — этикетка вышла бы просроченной.',
  'print.custom.print': 'Напечатать',
  'print.custom.copies': 'Количество',
  'print.custom.copiesHint': 'Сколько одинаковых этикеток напечатать — от 1 до {max}',
  'print.custom.copiesRange': 'Введите число от 1 до {max}',
  'print.custom.name': 'Наименование',
  'print.custom.nameHint': 'Что печатать вместо названия продукта.',
  'print.custom.endAt': 'Дата окончания',
  'print.custom.endAtHint': 'Если известна из документа поставщика.',
  'print.custom.startAt': 'Дата и время изготовления',
  'print.custom.startAtHint': 'От неё считается срок годности.',
  'print.custom.badFormat': 'Формат: ДД.ММ.ГГГГ ЧЧ:ММ. Проверьте, что такая дата существует.',
  'print.preview.title': 'Что напечатано',
  'print.preview.printedAt': 'Изготовлено',
  'print.preview.expiresAt': 'Годен до',
  'print.preview.storage': 'Хранение',
  'print.preview.keep': 'Хранить',
  'print.preview.brand': 'Рестомаркер',
  'print.preview.counter': '{n} из {total}',
  'print.printed': 'Напечатано: {name}',
  'print.batch.selectVisible': 'Выбрать всё видимое',
  'print.batch.deselectVisible': 'Снять всё видимое',
  'print.batch.selected': 'Выбрано: {n}',
  'print.batch.reset': 'Сбросить',
  'print.batch.printed': 'Партия из {n} этикеток',
  // Копии одной заготовки (T-044). Через «шт»: хелпера множественного числа нет.
  'print.copies.item': 'Напечатать {n} шт',
  'print.copies.field': 'Кол-во',
  'print.copies.count': '{n} шт',
  'print.copies.onlyOne': 'Несколько копий — когда выбрана одна заготовка',
  'print.copies.printed': 'Напечатано: {name} · {n} шт',
  'print.copies.cacheWarning':
    'Этикетки напечатаны и уйдут на сервер, но не сохранились на этом устройстве: без сети их не будет в «В работе» и журнале',
  'print.batch.expand': 'Показать',
  'print.batch.collapse': 'Свернуть',
  'print.batch.void': 'Аннулировать партию',
  'print.batch.void.title': 'Аннулировать партию?',
  'print.void': 'Аннулировать',
  'print.void.title': 'Аннулировать этикетку?',
  'print.void.confirm': 'Этикетку «{name}» пометить ошибочной. Физическую этикетку утилизируйте.',
  'print.void.submit': 'Подтвердить',
  'print.void.terminal':
    'Отменить аннулирование нельзя. Нужна корректная этикетка — напечатайте новую.',

  // --- Киоск: выбор сотрудника (T-012) ---
  'kiosk.nav.label': 'Разделы кухни',
  'kiosk.nav.print': 'Печать',
  'kiosk.nav.board': 'В работе',
  'kiosk.nav.printerSetup': 'Настройка принтера',
  'kiosk.nav.telegram': 'Уведомления',
  'catalog.product.nameTooLong':
    'Длинное название обрежется на этикетке — особенно на ленте 43×25 (помещается около 23 знаков).',

  // --- Настройка принтера (T-031) ---
  'printerSetup.title': 'Настройка принтера',
  'printerSetup.lead':
    'Выберите принтер из списка, напечатайте пробу и сохраните. Интернет не нужен.',
  'printerSetup.noBridge':
    'Подключение принтера доступно в приложении для планшета или в приложении на телефоне.',
  'printerSetup.noBridgeHint':
    'В браузере печать идёт в превью на экран. Установите приложение «Рестомаркер» — в нём принтер подключается по кабелю, Bluetooth-порту (планшет) или напрямую по Bluetooth (телефон).',
  'printerSetup.status.verified': 'Проверено пробной печатью',
  'printerSetup.status.unverified': 'Выбран, но проба не проходила',
  'printerSetup.disconnect': 'Отключить принтер',
  'printerSetup.waiting':
    'Ждём принтер: он просыпается после простоя или занят другим устройством — это до 2 минут.',
  'printerSetup.ports.title': 'Принтеры и порты',
  'printerSetup.ports.rescan': 'Обновить список',
  'printerSetup.ports.scanning': 'Поиск…',
  'printerSetup.ports.empty':
    'Ничего не найдено. Подключите принтер кабелем USB или спарьте по Bluetooth в параметрах Windows, затем обновите список.',
  'printerSetup.ports.emptyWinBt':
    'Ничего не найдено. Подключите принтер кабелем USB или нажмите «Найти принтер рядом» — Bluetooth-принтеру ни сопряжение, ни COM-порт не нужны.',
  'printerSetup.ports.emptyBt':
    'Спаренных принтеров нет. Включите принтер и нажмите «Найти принтер рядом».',
  'printerSetup.dev.winspool': 'принтер Windows (USB)',
  'printerSetup.dev.serial': 'COM-порт',
  'printerSetup.dev.bluetooth': 'Bluetooth',
  'printerSetup.dev.nearby': 'Bluetooth · рядом, не спарен',
  // Поиск рядом (решение владельца 2026-09-26): «зашёл в приложение, увидел принтер,
  // нажал „Подключиться“». Спаривать в настройках телефона больше не обязательно.
  'printerSetup.bt.findNearby': 'Найти принтер рядом',
  'printerSetup.bt.searching': 'Ищу принтеры рядом…',
  'printerSetup.bt.nothingNearby':
    'Рядом принтеров не нашлось. Проверьте, что принтер включён и стоит рядом, и повторите поиск.',
  'printerSetup.bt.scanPermissionDenied':
    'Без разрешения «Устройства поблизости» принтер рядом не найти. Разрешите его в настройках приложения или спарьте принтер в настройках Bluetooth.',
  'printerSetup.bt.nearbyUnsupported':
    'Поиск принтера из приложения появится после обновления приложения. Пока спарьте принтер в настройках Bluetooth.',
  'printerSetup.bt.needsPermission':
    'Чтобы увидеть спаренные принтеры, разрешите приложению доступ к Bluetooth.',
  'printerSetup.bt.grant': 'Разрешить доступ к Bluetooth',
  // Спаривание — действие системы; кнопка ведёт прямо на нужный экран настроек, а список
  // после возвращения обновляется сам.
  'printerSetup.bt.openSettings': 'Открыть настройки Bluetooth',
  'printerSetup.win.openSettings': 'Открыть параметры Bluetooth',
  'printerSetup.bt.afterSettings': 'Спарьте принтер и вернитесь сюда — список обновится сам.',
  'printerSetup.bt.settingsUnavailable':
    'Не получилось открыть настройки. Откройте Bluetooth в настройках телефона вручную.',
  'printerSetup.win.settingsUnavailable':
    'Не получилось открыть параметры. Откройте Bluetooth в параметрах Windows вручную.',
  'printerSetup.bt.off': 'Bluetooth выключен — без него принтер не найти.',
  'printerSetup.bt.enable': 'Включить Bluetooth',
  'printerSetup.bt.enableFailed':
    'Bluetooth не включился. Включите его в шторке или в настройках телефона.',
  'printerSetup.media.title': 'Размер ленты',
  'printerSetup.media.hint':
    'Размер этикетки — по коробке ленты. Пробная печать покажет, всё ли влезло.',
  'printerSetup.connect.button': 'Подключиться',
  'printerSetup.connect.connecting': 'Подключаюсь…',
  'printerSetup.connect.pairing': 'Спариваю с принтером…',
  // Windows: Bluetooth-сокет напрямую, без COM-порта (лестницы ступеней там нет).
  'printerSetup.connect.direct': 'напрямую по Bluetooth',
  'printerSetup.connect.ok': 'Подключено',
  'printerSetup.connect.failed': 'Подключиться не удалось',
  // Способ подключения показывается человеку намеренно: когда он звонит и говорит
  // «не работает», эта строка отвечает, докуда дошла лестница попыток.
  'printerSetup.connect.via': 'способ: {rung}',
  'printerSetup.test.button': 'Напечатать пробную этикетку',
  'printerSetup.test.printing': 'Печатаю пробу…',
  'printerSetup.test.ok': 'Проба напечатана и сохранена как принтер по умолчанию.',
  'printerSetup.test.failed': 'Проба не напечаталась',
  'printerSetup.test.product': 'ПРОБА ПЕЧАТИ',
  'printerSetup.test.fifo': 'проба',
  'printerSetup.test.storage': '+2…+6 °C',
  'printerSetup.saveUnverified': 'Сохранить без пробы',
  // Запрос состояния (Д9) — ручная проверка «что не так прямо сейчас», отдельно
  // от пробной печати («вообще работает ли связка»). Формат ответа — из спайка
  // T-035 на реальном V3BT: `ESC !?` → 1 байт, флаги складываются.
  'printerSetup.hwStatus.button': 'Проверить принтер',
  'printerSetup.hwStatus.checking': 'Проверяю…',
  'printerSetup.hwStatus.ready': 'Принтер готов',
  'printerSetup.hwStatus.coverOpen': 'Открыта крышка принтера',
  'printerSetup.hwStatus.paperOut': 'В принтере нет бумаги',
  'printerSetup.hwStatus.coverAndPaper': 'Открыта крышка, и в принтере нет бумаги',
  'printerSetup.hwStatus.failed': 'Не удалось получить статус',
  // BT Classic SPP-принтер держит одно соединение разом (T-035, живое железо):
  // недавно оборванная сессия блокирует новую тем же отказом, что и выключенный
  // принтер, и лечится только его перезагрузкой — единственное подтверждённое
  // лекарство. Показывается только для Bluetooth-принтера на телефоне.
  'printerSetup.bt.restartHint':
    'Если принтер точно включён и рядом — выключите его и включите заново кнопкой питания, затем повторите. Зависший слот Bluetooth-модуля принтера лечится только так.',
  'monitoring.tile.remaining': 'осталось',
  'monitoring.tile.overdue': 'просрочено на',
  'monitoring.kitchen.orderAlpha': 'По алфавиту',
  'monitoring.kitchen.search': 'Поиск по названию',
  'monitoring.kitchen.searchEmpty': 'Ничего не найдено',
  'monitoring.kitchen.searchEmptyHint': 'Проверьте написание или очистите поиск.',
  'kiosk.shift.total': 'на полке',
  'kiosk.shift.expired': 'просрочено',
  'kiosk.shift.soon': 'истекает',

  // --- Напоминание обойти полки (п.11) ---------------------------------------
  // «Проверено», а не «Проверил»: за смену у моноблока стоят разные люди, и род
  // в надписи на кнопке половине из них не подходит.
  'kiosk.shelfCheck.title': 'Пора проверить полки',
  'kiosk.shelfCheck.counts': 'По системе: истекает {soon}, просрочено {expired}.',
  'kiosk.shelfCheck.hint': 'Испорченное система не видит — нужен осмотр.',
  'kiosk.shelfCheck.done': 'Проверено',
  'kiosk.pair.title': 'Код привязки',
  'kiosk.pair.hint': 'Менеджер выдаёт его в кабинете: Устройства → Показать код.',
  'kiosk.pair.submit': 'Привязать устройство',
  'kiosk.leaveView': 'Вернуться в кабинет',
  'nav.kioskView': 'Кухня',
  'print.noLocation': 'Вам не назначена точка',
  'print.noLocationHint':
    'Печать привязана к точке: из неё берутся меню, сроки и часовой пояс. ' +
    'Обратитесь к менеджеру — он назначит точку в карточке сотрудника.',
  'print.graceExpired': 'Печать приостановлена',
  'print.graceExpiredHint':
    'Устройство слишком долго без связи, и срок работы на сохранённой лицензии истёк. ' +
    'Подключите его к сети — печать возобновится сразу.',
  'print.neverSynced': 'Устройство ещё не связывалось с сервером',
  'print.neverSyncedHint':
    'Пока связи не было ни разу, часы устройства не с чем сверить — а на них считается ' +
    'срок годности. Подключите к сети один раз, дальше можно работать офлайн.',
  'print.suspendedHint':
    'Печать для вашей сети отключена. Обратитесь к администратору сети или в поддержку ' +
    'Рестомаркера — после включения печать заработает сразу.',
  'print.graceWarning':
    'Связи нет. Печать работает ещё {n} дн. — подключите устройство к сети, чтобы продлить.',
  // Печать на утро (T-055).
  'print.morning.toggle': 'На утро',
  'print.morning.button': 'Печать на утро',
  'print.morning.tomorrow': 'завтра {time}',
  'print.morning.today': 'сегодня {time}',
  'print.clockDrift': 'Часы устройства сбиты',
  'print.clockDriftHint':
    'Время на этом устройстве расходится с сервером больше чем на 5 минут, поэтому дата и ' +
    'срок годности на этикетке вышли бы неверными. Включите автоматическую установку даты ' +
    'и времени в настройках устройства и нажмите «Обновить».',
  'print.noTimezone': 'Не задана зона точки',
  'print.noTimezoneHint':
    'Срок годности считается в часовом поясе точки, и без него дата на этикетке будет ' +
    'неверной. Обратитесь к менеджеру: зона задаётся в карточке точки.',
  'kiosk.notPaired': 'Устройство не привязано',
  'kiosk.notPairedHint': 'Попросите менеджера выдать код привязки в кабинете.',

  // --- Точки сети (T-005) ---
  'locations.pageTitle': 'Точки сети',
  'locations.subtitle': 'Рестораны и цеха сети. У каждой точки своё меню и свой часовой пояс.',
  'locations.add': 'Создать точку',
  'locations.kiosks.title': 'Планшеты/телефоны для входа по PIN',
  'locations.kiosks.column.name': 'Планшет/телефон',
  'locations.kiosks.column.location': 'Точка',
  'locations.kiosks.column.lastUsed': 'Последний вход по PIN',
  'locations.kiosks.never': 'ещё не было',
  'locations.kiosks.empty':
    'Закреплённых планшетов/телефонов нет. Закрепить можно на самом планшете/телефоне: перейдите в вид «{view}» и нажмите «{menu}».',
  'locations.kiosks.revoke': 'Открепить',
  'locations.kiosks.revokeTitle': 'Открепить планшет/телефон?',
  'locations.kiosks.revokeText':
    'На нём перестанут работать PIN-коды, а вошедший по PIN сотрудник будет разлогинен при следующем обращении к серверу.',
  'locations.column.name': 'Название',
  'locations.column.address': 'Адрес',
  'locations.column.timezone': 'Часовой пояс',
  // Списание разом на табло (T-052): галочки ставит админ сети.
  'locations.column.board': 'Списание разом',
  'locations.board.none': 'Поштучно',
  'locations.board.expiredShort': 'Просроченные',
  'locations.board.allShort': 'Все',
  'locations.board.open': 'Списание на табло',
  'locations.board.title': 'Списание на табло — {name}',
  'locations.board.description':
    'Что сотрудники точки могут отметить на табло одной кнопкой. Списывают всё равно кнопкой «Списать» с подтверждением.',
  'locations.board.expired': 'Выбирать все просроченные разом',
  'locations.board.expiredHint': 'Кнопка «Выбрать просроченные» — для утреннего обхода полок.',
  'locations.board.all': 'Выбирать все этикетки разом',
  'locations.board.allHint':
    'Кнопка «Выбрать все» отмечает и годные: смена меню, отказ холодильника. Без галочек каждую этикетку отмечают тапом.',
  // Печать на утро (T-055): галочку и время ставит админ сети.
  'locations.column.preprint': 'Печать на утро',
  'locations.preprint.off': 'Выключена',
  'locations.preprint.at': 'С {time}',
  'locations.preprint.open': 'Печать на утро',
  'locations.preprint.title': 'Печать на утро: {name}',
  'locations.preprint.description':
    'Вечером перед закрытием этикетки можно напечатать временем изготовления следующего утра. Срок годности считается от этого времени.',
  'locations.preprint.enabled': 'Разрешить печать на утро',
  'locations.preprint.enabledHint':
    'В шапке экрана печати появится тумблер «На утро». Пока он включён, этикетки печатаются временем утра. Клейте их только на то, что приготовят к утру, иначе срок годности окажется длиннее настоящего.',
  'locations.preprint.time': 'Время утра',
  'locations.preprint.timeHint':
    'Четыре цифры, например 0800. Местное время точки ({tz}). Вечером на этикетку пойдёт завтрашнее утро, после полуночи сегодняшнее.',
  'locations.preprint.timeInvalid':
    'Такого времени нет. Введите часы от 00 до 23 и минуты от 00 до 59.',
  'locations.emptyTitle': 'Точек пока нет',
  'locations.emptyText': 'Создайте первую точку — меню приедет в неё копией каталога сети.',
  'locations.createdWithCatalog': 'создана. В меню приехало позиций: {n}.',
  'locations.createdEmpty': 'создана. Меню пустое — добавьте позиции вручную.',
  'locations.form.create': 'Новая точка',
  'locations.form.description':
    'Точка появится сразу с меню, если оставить копирование включённым.',
  'locations.form.name': 'Название',
  'locations.form.address': 'Адрес',
  'locations.form.timezone': 'Часовой пояс',
  'locations.form.timezoneHint': 'В нём считаются сроки годности и печатается время на этикетке.',
  'locations.form.notes': 'Заметка',
  'locations.form.notesHint': 'Видна только вам: этаж, вход, чей это цех. На этикетку не попадает.',
  'locations.form.cloneCatalog': 'Скопировать каталог сети в меню точки',
  'locations.form.cloneCatalogHint': 'Иначе точка откроется с пустым меню и печатать будет нечего.',

  'staff.pageTitleNetwork': 'Сотрудники сети',
  'staff.pageTitleLocation': 'Сотрудники точки',
  'staff.subtitleNetwork': 'Все пользователи сети: роли, точки и доступ.',
  // «Выбираются карточкой на устройстве» — механизм, удалённый в T-018: вход
  // у сотрудника такой же, как у всех, логином и паролем.
  'staff.subtitleLocation': 'Сотрудники вашей точки. Каждый входит своим логином и паролем.',
  'staff.addUser': 'Добавить пользователя',
  'staff.addEmployee': 'Добавить сотрудника',
  'staff.search': 'Поиск по ФИО',
  'staff.column.tenant': 'Сеть',
  'staff.column.name': 'ФИО',
  'staff.column.email': 'Email',
  'staff.column.role': 'Роль',
  'staff.column.locations': 'Точек',
  'staff.invited': 'Приглашён',
  'staff.blocked': 'Заблокирован',
  'staff.self': 'это вы',
  'staff.block': 'Заблокировать',
  'staff.unblock': 'Разблокировать',
  'staff.delete': 'Удалить',
  'staff.restore': 'Вернуть из корзины',
  'staff.trash': 'Корзина',
  'staff.backToList': 'К списку',
  'staff.trashTitle': 'Корзина',
  // Главное, что человек должен понять на этом экране: удаление не стирает историю.
  // Без этой строки менеджер либо боится удалять, либо удаляет и ждёт, что печать
  // уволенного исчезнет из журнала.
  'staff.trashLede':
    'Удалённые сотрудники. Их печать остаётся в журнале и отчётах — удаление убирает ' +
    'человека из списков и с планшетов/телефонов, но не стирает то, что он напечатал.',
  'staff.trashEmpty': 'Удалённых сотрудников нет.',
  'staff.deleteConfirm':
    'Удалить {name}? Человек исчезнет из списков и с планшетов/телефонов точки, а его печать ' +
    'останется в журнале. Вернуть можно из корзины.',
  'staff.restoredHint': 'Вернулся заблокированным — разблокируйте, когда выйдет на смену.',
  'staff.role.employee': 'Сотрудник',
  'staff.role.manager': 'Менеджер точки',
  'staff.form.create': 'Новый пользователь',
  'staff.form.edit': 'Изменение пользователя',
  'staff.form.fullName': 'ФИО',
  'staff.form.role': 'Роль',
  'staff.column.location': 'Точка',
  'staff.moreLocations': '+ ещё {n}',
  'staff.noLocation': 'не назначена',
  'staff.searchPlaceholder': 'Например: Иванов',
  'staff.setPassword': 'Выдать новый пароль',
  'staff.setPin': 'Задать PIN',
  'staff.setPin.title': 'PIN для входа на планшете/телефоне',
  'staff.setPin.hint':
    'Четыре цифры. Сотрудник вводит их на планшете/телефоне, закреплённом за его точкой. Прежний PIN перестанет работать.',
  'staff.noPin': 'нет PIN',
  'staff.form.pin': 'PIN для планшета/телефона',
  'staff.form.pinHint':
    'Четыре цифры — для входа на планшете/телефоне точки. Сотрудник сам его не меняет.',
  'staff.setPassword.title': 'Новый пароль сотрудника',
  'staff.setPassword.hint':
    'Старый перестанет работать сразу. Продиктуйте новый сотруднику — другого пути ' +
    'войти у него нет: письма на служебный адрес не уходят.',
  'staff.setPassword.done': 'Пароль выдан',
  'staff.form.password': 'Пароль для входа',
  // `type="text"`, а не `password`: менеджер этот пароль ПРОДИКТУЕТ повару, и точки
  // вместо символов мешают ровно тому, ради чего поле существует. Секретом он не
  // является — это первый пароль, выданный руками.
  'staff.form.passwordHint':
    'Не короче 8 символов, минимум одна цифра. Продиктуйте его сотруднику.',
  'staff.created.title': 'Сотрудник создан',
  'staff.created.hint':
    'Передайте эти данные сотруднику — войти он может только ими. Логин сгенерирован автоматически, ' +
    'потом его видно в списке персонала.',
  'staff.created.login': 'Логин',
  'staff.created.password': 'Пароль',
  'staff.created.pin': 'PIN для планшета/телефона',
  'staff.form.email': 'Email',
  'staff.form.emailManager': 'Обязателен: на него уходит приглашение с доступом в кабинет.',
  // Текст описывал вход КАРТОЧКОЙ на устройстве — механизм, удалённый в T-018.
  // Сотрудник давно входит логином и паролем, как все; необязательно поле не потому,
  // что вход другой, а потому что адрес генерирует система (решение Д1): почты
  // у повара нет, а придуманный менеджером `povar1@` выглядел бы настоящим и молча
  // не доставлял письма.
  'staff.form.emailEmployee':
    'Можно не заполнять — адрес для входа сгенерируется автоматически. Заполните, если у сотрудника есть рабочая почта.',
  // Роль показывается текстом, когда её нельзя назначить из этой формы (B-033):
  // селект не умеет отобразить значение, которого нет в его списке, и подставлял
  // «Сотрудника» — карточка админа выглядела карточкой повара.
  'staff.form.roleFixed': 'Роль: {role}. Изменить её из этой формы нельзя.',
  'staff.role.platformAdmin': 'Платформа-Админ',
  'staff.role.clientAdmin': 'Админ сети',
  'staff.form.locations': 'Точки',
  'staff.form.defaultLocation': 'Основная точка',
  'staff.form.defaultLocationPlaceholder': 'Не выбрана',
  'staff.form.defaultLocationHint':
    'Куда попадёт человек после входа. Только из привязанных точек.',
  'staff.emptyTitle': 'Пока никого нет',
  'staff.emptyNetwork': 'Добавьте менеджеров точек и сотрудников — им уйдут приглашения.',
  'staff.emptyLocation': 'Добавьте сотрудников: без них некому подписывать печать этикеток.',

  // --- Сессия --------------------------------------------------------------
  'session.loading': 'Загрузка профиля…',
  'session.error': 'Не удалось получить профиль пользователя. Войдите заново.',
  'session.noLocation': 'У вас не выбрана основная точка — меню показать не из чего.',

  // --- Восстановление пароля -------------------------------------------------
  // Восстановления по почте пока нет: почтовый сервер не подключён, и ссылка никуда
  // не уходит. Новый пароль выдают в карточке сотрудника.
  'auth.reset.askAdmin': 'Забыли пароль — попросите менеджера или владельца сети выдать новый.',

  // --- Вход по PIN на закреплённом планшете/телефоне (T-040) ------------------
  'auth.kiosk.title': 'Кто на смене?',
  'auth.kiosk.loading': 'Загружаем сотрудников…',
  'auth.kiosk.offline': 'Нет сети — сменить сотрудника сейчас нельзя.',
  'auth.kiosk.retry': 'Повторить',
  'auth.kiosk.empty': 'На этой точке пока нет сотрудников. Их заводит менеджер в кабинете.',
  'auth.kiosk.noPin': 'PIN не задан — обратитесь к менеджеру',
  'auth.kiosk.notYou': 'Не вы?',
  'auth.kiosk.enterPin': 'Введите PIN',
  'auth.kiosk.invalidPin': 'Неверный PIN',
  'auth.kiosk.locked': 'Слишком много неверных попыток. Попробуйте через {minutes} мин.',
  'auth.kiosk.backspace': 'Стереть цифру',
  'auth.kiosk.passwordLogin': 'Вход по паролю',
  'auth.kiosk.backToCards': 'Назад к сотрудникам',

  // --- Закрепление планшета/телефона за точкой (T-040) ------------------------
  'kiosk.bind.menu': 'Закрепить планшет/телефон за точкой',
  'kiosk.bind.menuBound': 'Планшет/телефон закреплён: {name}',
  'kiosk.bind.title': 'Закрепить планшет/телефон за точкой',
  'kiosk.bind.description':
    'После выхода из аккаунта здесь появятся карточки сотрудников точки — они будут входить по PIN.',
  'kiosk.bind.location': 'Точка',
  'kiosk.bind.name': 'Имя планшета/телефона',
  'kiosk.bind.nameHint':
    'Например, «Кухня, у плиты» — по нему найдёте планшет/телефон в кабинете, если он пропадёт.',
  'kiosk.bind.submit': 'Закрепить',
  'kiosk.bind.done': 'Планшет/телефон закреплён за точкой «{location}».',
  'kiosk.bind.logoutNow': 'Выйти и показать карточки',
  'kiosk.bind.already': 'Этот планшет/телефон закреплён за точкой «{location}» как «{name}».',
  'kiosk.bind.revoke': 'Открепить этот планшет/телефон',
  'kiosk.bind.revokeDone': 'Планшет/телефон откреплён. Вход снова по логину и паролю.',
  'kiosk.bind.noLocations': 'У вас нет точек, за которыми можно закрепить планшет/телефон.',

  // --- Статистика (T-057) ----------------------------------------------------
  'stats.pageTitle': 'Статистика',
  'stats.period': 'Период',
  'stats.preset.week': '7 дней',
  'stats.preset.month': '30 дней',
  'stats.preset.thisMonth': 'Этот месяц',
  'stats.since': 'С даты',
  'stats.until': 'По дату',
  'stats.allLocations': 'Все точки',
  'stats.network': 'Сеть',
  'stats.locations': 'Точки',
  'stats.locationsChosen': 'Выбрано {count} из {total}',
  'stats.locationsApply': 'Показать',
  'stats.pickNetworkFirst': 'Сначала выберите сеть',
  'stats.allNetworks': 'Все сети',
  'stats.invalidPeriod': 'Дата начала позже даты конца.',
  'stats.export': 'Скачать для Excel',
  'stats.errorTitle': 'Статистика не загрузилась',
  'stats.errorText': 'Проверьте связь и попробуйте ещё раз.',
  'stats.emptyTitle': 'За этот период ничего не печатали',
  'stats.emptyText': 'Выберите другой период или точку.',
  'stats.total.printed': 'Напечатано',
  'stats.total.disposed': 'Списано',
  'stats.total.voided': 'Аннулировано',
  'stats.total.expired': 'Просрочено, не списано',
  'stats.chart.title': 'По дням',
  'stats.section.locations': 'По точкам',
  'stats.section.employees': 'По сотрудникам',
  'stats.section.products': 'По продуктам',
  'stats.col.date': 'Дата',
  'stats.col.location': 'Точка',
  'stats.col.employee': 'Сотрудник',
  'stats.col.product': 'Продукт',
  'stats.col.printed': 'Напечатано',
  'stats.col.disposed': 'Списано',
  'stats.col.voided': 'Аннулировано',
  'stats.col.expired': 'Просрочено',
  'stats.unknownEmployee': 'Удалённый сотрудник',
  'stats.products.all': 'Показать все ({count})',
  'stats.products.less': 'Свернуть',

  // --- Навигация ------------------------------------------------------------
  'nav.label': 'Разделы кабинета',
  'nav.print': 'Печать',
  'nav.monitoring': 'Мониторинг',
  'nav.journal': 'Журнал',
  'nav.stats': 'Статистика',
  'nav.menu': 'Меню точки',
  'nav.masterCatalog': 'Каталог сети',
  'nav.categories': 'Категории сроков',
  'nav.staff': 'Сотрудники',
  'nav.locations': 'Точки',
  'nav.analytics': 'Аналитика',
  'nav.referenceCatalog': 'Эталонный каталог',
  'nav.tenantsAdmin': 'Сети',
  'nav.releasesAdmin': 'Релизы приложений',
  'catalog.master.referenceTitle': 'Эталонный каталог',

  // Сети платформы (T-042).
  'tenants.pageTitle': 'Сети',
  'tenants.create': 'Завести сеть',
  'tenants.createSubmit': 'Завести',
  'tenants.createFailed': 'Не удалось завести сеть. Повторите.',
  'tenants.search': 'Поиск по названию',
  'tenants.filter.status': 'Статус',
  'tenants.filter.working': 'Работают и на паузе',
  'tenants.col.name': 'Сеть',
  'tenants.col.subscription': 'Подписка',
  'tenants.col.price': 'Цена в месяц',
  'tenants.col.locations': 'Точек',
  'tenants.col.users': 'Людей',
  'tenants.col.owner': 'Владелец',
  'tenants.until': 'до {date}',
  'tenants.noEnd': 'без срока',
  'tenants.ownerInvited': 'приглашён, ещё не входил',
  'tenants.noOwner': 'владельца нет',
  'tenants.emptyTitle': 'Сетей нет',
  'tenants.emptyText': 'Заведите первую — с владельцем, который получит приглашение.',
  'tenants.emptyFiltered': 'Под отбор ничего не попало. Измените поиск или статус.',
  'tenants.back': '← Сети',
  'tenants.notFound': 'Сеть не найдена',
  'tenants.notFoundText': 'Возможно, адрес устарел. Вернитесь к списку сетей.',
  'tenants.section.details': 'Реквизиты',
  'tenants.section.subscription': 'Подписка и тариф',
  'tenants.section.owner': 'Владелец',
  'tenants.section.history': 'История',
  'tenants.section.locations': 'Точки',
  'tenants.section.people': 'Админы и менеджеры',
  'tenants.locations.add': 'Добавить точку',
  'tenants.locations.addHint': 'Меню точки заполнится из каталога сети.',
  'tenants.locations.create': 'Создать точку',
  'tenants.locations.name': 'Название точки',
  'tenants.locations.address': 'Адрес',
  'tenants.locations.empty': 'Точек пока нет.',
  'tenants.locations.paused': 'Отключена',
  'tenants.locations.pause': 'Отключить',
  'tenants.locations.resume': 'Подключить',
  'tenants.rowActions': 'действия',
  'tenants.more': 'Подробнее: реквизиты, подписка, «Войти как…», история',
  'tenants.network.status': 'Состояние сети',
  'tenants.network.active': 'Сеть работает',
  'tenants.network.paused': 'Сеть отключена',
  'tenants.network.activeHint': 'Печатают все точки, кроме отключённых.',
  'tenants.network.pausedHint':
    'Печать остановлена на всех точках. Вход, журнал и мониторинг работают, данные на месте.',
  'tenants.network.pause': 'Отключить сеть',
  'tenants.network.resume': 'Подключить сеть',
  'tenants.network.confirmTitle': 'Отключить сеть «{name}»?',
  'tenants.network.confirmText':
    'Печать этикеток остановится на всех точках сети. Подключить обратно можно в любой момент — всё заработает как раньше.',
  'tenants.people.add': 'Добавить человека',
  'tenants.people.hint':
    'Вход сразу по паролю, без письма. Поваров заводят менеджер точки и админ сети.',
  'tenants.people.create': 'Создать и выдать пароль',
  'tenants.people.role': 'Роль',
  'tenants.people.role.admin': 'Админ сети',
  'tenants.people.role.manager': 'Менеджер точки',
  'tenants.people.fullName': 'ФИО',
  'tenants.people.email': 'Email (логин)',
  'tenants.people.emailHint': 'По нему человек входит. Письмо не отправляется.',
  'tenants.people.locations': 'Точки менеджера',
  'tenants.people.noLocations': 'Сначала добавьте точку.',
  'tenants.people.blocked': 'заблокирован',
  'tenants.people.issuePassword': 'Выдать пароль',
  'tenants.people.issueHint': 'старый пароль перестанет действовать, открытые сессии закроются',
  'tenants.people.issued': 'Пароль выдан',
  'tenants.people.issuedHint':
    'Передайте логин и пароль человеку сейчас: повторно пароль не показывается.',
  'tenants.field.name': 'Название сети',
  'tenants.field.contactEmail': 'Контактный email',
  'tenants.field.phone': 'Телефон',
  'tenants.field.notes': 'Внутренние заметки',
  'tenants.field.ownerName': 'ФИО владельца',
  'tenants.field.ownerEmail': 'Email владельца',
  'tenants.field.status': 'Статус сети',
  'tenants.field.planTier': 'Тариф',
  'tenants.field.subscriptionStatus': 'Подписка',
  'tenants.field.validUntil': 'Действует до',
  'tenants.field.graceDays': 'Льготный период, дней',
  'tenants.field.maxLocations': 'Лимит точек',
  'tenants.field.maxEmployees': 'Лимит людей',
  'tenants.field.price': 'Цена, ₽ в месяц',
  'tenants.notesHint': 'Клиент их не видит.',
  'tenants.priceHint': 'Пусто — цена не задана, 0 — бесплатный пилот.',
  'tenants.graceHint': 'Пусто — по умолчанию платформы.',
  'tenants.limitHint': 'Сейчас: {count}. Пусто — без лимита.',
  'tenants.statusHint':
    '«Приостановлена» — отключение, например за неуплату: печать останавливается на всех ' +
    'устройствах сети, вход, журнал и мониторинг работают. Данные сохраняются.',
  'tenants.sendInvite': 'Сразу отправить владельцу приглашение',
  'tenants.saved': 'Сохранено',
  'tenants.saveFailed': 'Не удалось сохранить. Повторите.',
  'tenants.resendInvite': 'Отправить приглашение повторно',
  'tenants.inviteSent': 'Приглашение отправлено',
  'tenants.inviteFailed': 'Письмо не ушло. Проверьте адрес и повторите.',
  'tenants.status.active': 'Работает',
  'tenants.status.paused': 'Приостановлена',
  'tenants.status.archived': 'Архив',
  'tenants.plan.pilot': 'Пилот',
  'tenants.history.baseline': 'Точка отсчёта истории подписки',
  'tenants.history.system': 'система',
  'tenants.history.empty': 'Записей пока нет.',

  // Релизы платформы (T-042).
  'releases.pageTitle': 'Релизы приложений',
  'releases.lede':
    'Устройства получают самую свежую включённую версию. Отключить свежую — откатить всех на предыдущую.',
  'releases.web': 'Веб-слой (обновление по воздуху)',
  'releases.app': 'Установщики',
  'releases.col.version': 'Версия',
  'releases.col.state': 'Состояние',
  'releases.col.date': 'Опубликована',
  'releases.col.notes': 'Заметки',
  'releases.col.size': 'Размер',
  'releases.served': 'Раздаётся сейчас',
  'releases.active': 'Включена',
  'releases.inactive': 'Отключена',
  'releases.disable': 'Отключить',
  'releases.enable': 'Включить',
  'releases.disableTitle': 'Отключить {version}?',
  'releases.enableTitle': 'Включить {version}?',
  'releases.disableText':
    'Если это самая свежая включённая версия, устройства вернутся на предыдущую при следующей проверке обновлений.',
  'releases.enableText':
    'Если это самая свежая версия, устройства получат её при следующей проверке обновлений.',
  'releases.emptyTitle': 'Выпусков нет',
  'releases.empty': 'Их публикует CI командами publish_web_release и publish_app_release.',

  // Саппорт-сессия платформы (T-039).
  'support.readOnly': 'Саппорт-сессия только для просмотра. Подскажите клиенту, что нажать.',
  'support.end': 'Завершить',
  'support.viewAs': 'Войти как…',
  'support.dialogTitle': 'Войти как пользователь сети',
  'support.dialogText':
    'Вы увидите кабинет его глазами — только для просмотра. Вход и причина попадут в журнал.',
  'support.user': 'Пользователь',
  'support.userPlaceholder': 'Выберите пользователя',
  'support.reason': 'Причина',
  'support.reasonHint': 'Зачем входите: разбор жалобы, настройка по звонку… Не короче 5 символов.',
  'support.submit': 'Войти',
  'support.noUsers': 'В сети нет активных пользователей.',
  'support.failed': 'Не удалось начать саппорт-сессию.',
  'support.role.client_admin': 'владелец сети',
  'support.role.location_manager': 'менеджер точки',
  'support.role.employee': 'сотрудник',

  // Продуктовая аналитика платформы (T-038).
  'platform.analytics.pageTitle': 'Аналитика',
  'platform.analytics.period': 'Период',
  'platform.analytics.periodDays': '{days} дней',
  'platform.analytics.groups': 'Группа показателей',
  'platform.analytics.group.activity': 'Активность',
  'platform.analytics.group.onboarding': 'Внедрение',
  'platform.analytics.group.health': 'Здоровье',
  'platform.analytics.group.subscription': 'Подписки',
  'platform.analytics.group.features': 'Функции',
  'platform.analytics.group.friction': 'Трудности',
  'platform.analytics.total.active': 'Сети печатали',
  'platform.analytics.total.prints': 'Печатей',
  'platform.analytics.total.mrr': 'Выручка в месяц',
  'platform.analytics.total.priceMissing': 'без цены: {count}',
  'platform.analytics.total.trialToPaid': 'Пилот → оплата',
  'platform.analytics.total.churned': 'Ушли',
  'platform.analytics.t041None':
    'Входы, версии приложения, способ печати и история подписки пока не записываются — эти показатели пусты.',
  'platform.analytics.t041Since':
    'Входы, версии приложения, способ печати и история подписки записываются с {date}: за время до этой даты данных нет.',
  'platform.analytics.noData': 'нет данных',
  'platform.analytics.priceMissing': 'не задана',
  'platform.analytics.never': 'не печатала',
  'platform.analytics.today': 'сегодня',
  'platform.analytics.daysAgo': '{days} дн. назад',
  'platform.analytics.days': '{days} дн.',
  'platform.analytics.hours': '{hours} ч',
  'platform.analytics.within24h': 'за сутки: {ratio}',
  'platform.analytics.graceLeft': 'льготный период: {days} дн.',
  'platform.analytics.stuckOn': 'нет шага: {step}',
  'platform.analytics.step.location': 'точка',
  'platform.analytics.step.menu': 'меню',
  'platform.analytics.step.staff': 'сотрудники',
  'platform.analytics.step.firstPrint': 'первая печать',
  'platform.analytics.mode.all': 'Полная',
  'platform.analytics.mode.free': 'Своя',
  // Три исторических режима (T-022 объединил их в «свою этикетку»). Новых печатей
  // с этими кодами не будет, а старые в аналитике попадаются — подписи взяты
  // из `PrintMode` на сервере, чтобы отчёт и журнал называли одно одинаково.
  'platform.analytics.mode.allDates': 'Своё название',
  'platform.analytics.mode.startOnly': 'Своя дата окончания',
  'platform.analytics.mode.custom': 'Своя дата начала',
  'platform.analytics.sub.trial': 'Пилот',
  'platform.analytics.sub.active': 'Оплачена',
  'platform.analytics.sub.expired': 'Истекла',
  'platform.analytics.sub.paused': 'приостановлена',
  'platform.analytics.col.tenant': 'Сеть',
  'platform.analytics.col.printDays': 'Дней с печатью',
  'platform.analytics.chart.prints': 'Печати',
  'platform.analytics.chart.now': 'этот период',
  'platform.analytics.chart.prev': 'прошлый',
  'platform.analytics.chart.prevShort': 'прошлый:',
  'platform.analytics.chart.byWeek': 'по неделям',
  'platform.analytics.chart.summary': '{title}: {now} за период, в прошлом таком же — {prev}',
  'platform.analytics.col.lastPrint': 'Последняя печать',
  'platform.analytics.col.prints': 'Печатей',
  'platform.analytics.col.activeLocations': 'Точки печатали',
  'platform.analytics.col.staff': 'Людей',
  'platform.analytics.col.steps': 'Шаги внедрения',
  'platform.analytics.col.toFirstPrint': 'До первой печати',
  'platform.analytics.col.toSteady': 'До устойчивой работы',
  'platform.analytics.col.expiredNow': 'Просрочено сейчас',
  'platform.analytics.col.disposeReaction': 'Реакция на просрочку',
  'platform.analytics.col.voidRatio': 'Аннулирований',
  'platform.analytics.col.clockDrift': 'Сбитые часы',
  'platform.analytics.col.printerRatio': 'На принтер',
  'platform.analytics.col.tapes': 'Ленты',
  'platform.analytics.col.subscription': 'Подписка',
  'platform.analytics.col.validUntil': 'Действует до',
  'platform.analytics.col.price': 'Цена в месяц',
  'platform.analytics.col.locationsLimit': 'Точки / лимит',
  'platform.analytics.col.staffLimit': 'Люди / лимит',
  'platform.analytics.col.modes': 'Режимы печати',
  'platform.analytics.col.batches': 'Партиями',
  'platform.analytics.col.reprints': 'Перепечаток',
  'platform.analytics.col.disposals': 'Списаний',
  'platform.analytics.col.pinLogins': 'Вход по PIN',
  'platform.analytics.col.kiosks': 'Планшетов/телефонов',
  'platform.analytics.col.failedLogins': 'Неудачных входов',
  'platform.analytics.col.pinLocks': 'Паузы PIN',
  'platform.analytics.col.passwordIssues': 'Выдач паролей',
  'platform.analytics.col.emailFailures': 'Писем не ушло',
  'platform.analytics.col.oldestShell': 'Старейшее приложение',
  'platform.analytics.emptyTitle': 'Сетей нет',
  'platform.analytics.emptyText': 'Заведите первую сеть — её показатели появятся здесь.',
  'platform.analytics.errorTitle': 'Аналитика не загрузилась',
  'platform.analytics.errorText': 'Сервер не ответил. Проверьте связь и повторите.',
  'nav.logout': 'Выйти',
  'nav.telegram': 'Настроить уведомления',

  // --- Подключение Telegram (п.11) -------------------------------------------
  'notifications.title': 'Уведомления',
  'notifications.description':
    'Утром в Telegram приходит сводка по точке. А предупреждения заранее, когда у заготовки подходит срок, можно получать в Telegram, push-уведомлением на телефон — или и так, и так.',
  'notifications.descriptionStaff':
    'Предупреждения заранее, когда у заготовки подходит срок, — чтобы успеть реализовать её или подготовить к утилизации. В Telegram, push-уведомлением на телефон — или и так, и так.',
  'notifications.telegram': 'Telegram',
  // Push принадлежит человеку и приходит на все его телефоны (B-039), поэтому
  // «на этот телефон» из подписей ушло: снять галочку здесь — выключить push везде.
  'push.section': 'Push на телефон',
  'push.toggle': 'Присылать push-предупреждения',
  'push.hint': 'На каждый телефон, где вы вошли в Рестомаркер, — даже когда приложение закрыто.',
  'push.connectedHere': 'Этот телефон получает предупреждения.',
  'push.blocked':
    'Этот телефон не показывает уведомления Рестомаркера. Разрешите их: Настройки → Приложения → Рестомаркер → Уведомления.',
  'push.allow': 'Разрешить уведомления',
  'push.failed':
    'Этот телефон пока не подключён: Google не выдал адрес для уведомлений. Повторим при следующем запуске. Не помогает — перезагрузите телефон.',
  'push.elsewhere':
    'Push приходит на телефоны, где вы вошли в Рестомаркер. На этом устройстве его нет.',
  'push.open': 'Открыть «В работе»',
  'telegram.alerts': 'Предупреждать заранее о сроках',
  // Формулы здесь больше нет: когда предупреждать, говорят сами галочки под ней (T-046).
  'telegram.alertsHint': 'По каждой заготовке точки, ночью тоже.',
  'telegram.alertsHintLegacy':
    'За половину срока (но не раньше чем за сутки) и за час до конца — по каждой заготовке точки, ночью тоже.',
  'telegram.qrHint': 'Наведите камеру телефона на код — откроется бот. Нажмите в нём «Начать».',
  'telegram.qrLabel': 'QR-код ссылки на бота Рестомаркера',
  'telegram.connect': 'Подключить',
  'telegram.connected': 'Подключён аккаунт {name}.',
  'telegram.disconnect': 'Отключить',
  'telegram.linkHint': 'Или откройте бота на этом устройстве и нажмите «Начать».',
  'telegram.openBot': 'Открыть бота',
  'telegram.fallback':
    'Если бот открылся, но подключение не произошло, отправьте ему эту команду вручную:',
  // Несколько чатов на учётке (T-058): у общей учётки точки у каждого свой Telegram.
  'telegram.chats': 'Подключённые чаты Telegram',
  'telegram.chatsHint':
    'Каждый подключает свой Telegram: «Подключить ещё» и QR-код камерой своего телефона. Если чат отключить или снять у него галочку, бот сообщит об этом в чат.',
  'telegram.connectMore': 'Подключить ещё',
  'telegram.cancelLink': 'Отмена',
  'telegram.chatSince': 'с {date}',
  'telegram.chatAlerts': 'Предупреждения о сроках',
  'telegram.chatDigest': 'Утренняя сводка',
  'telegram.disconnectChat': 'Отключить чат {name}',
  'telegram.whenChats': 'Когда предупреждать в Telegram',

  // --- Пороги предупреждений о сроках (T-046) ---------------------------------
  // Подпись порога строится из кода с сервера (`alerts.tier.<код>`): код, которого здесь
  // нет, окно не рисует, но и не теряет — он остаётся в наборе человека.
  'alerts.when': 'Когда предупреждать',
  'alerts.whenMine': 'Когда присылать мне',
  'alerts.whenLocation': 'Когда показывать на устройствах точки',
  'notifications.group.location': 'Для всей точки',
  'notifications.group.locationHint':
    'Одно на всех, кто работает на точке, и на все её устройства.',
  'notifications.group.mine': 'Лично мне',
  'notifications.group.mineHint': 'Только вам — в Telegram или push на ваш телефон.',
  'alerts.tier.expiring': 'За половину срока',
  'alerts.halfHint': 'не раньше чем за сутки до конца',
  'alerts.leads': 'За сколько до конца:',
  'alerts.tier.lead_30': '30 мин',
  'alerts.tier.last_hour': '1 ч',
  'alerts.tier.lead_120': '2 ч',
  'alerts.tier.lead_180': '3 ч',
  'alerts.tier.lead_240': '4 ч',
  'alerts.tier.lead_300': '5 ч',
  'alerts.tier.lead_360': '6 ч',
  'alerts.whenHint':
    'Каждая отметка — отдельное предупреждение по каждой заготовке точки. Если срок заготовки короче выбранного, по ней оно не придёт.',
  'alerts.lastOne':
    'Хотя бы один срок остаётся отмеченным. Чтобы не получать предупреждения, снимите галочку канала выше.',
  'alerts.offline': 'Нет сети — настройки уведомлений меняются только при подключении.',
  'alerts.saveFailed': 'Не сохранилось. Проверьте связь и попробуйте ещё раз.',
  'alerts.loadFailed': 'Настройки уведомлений не загрузились. Попробуйте ещё раз.',

  // --- Лента предупреждений точки и уведомления Windows (T-047) ---------------
  'alerts.feed.nav': 'Уведомления',
  'alerts.feed.navUnread': 'Уведомления: {count} новых',
  'alerts.feed.title': 'Уведомления',
  'alerts.feed.subtitle': 'Готовьтесь к утилизации или реализуйте продукт.',
  'alerts.feed.settings': 'Настроить',
  'alerts.feed.location': 'Точка',
  'alerts.feed.today': 'Сегодня',
  'alerts.feed.yesterday': 'Вчера',
  'alerts.feed.new': 'Новые',
  'alerts.feed.more': 'Ещё {count}',
  'alerts.feed.older': 'Показать раньше',
  'alerts.feed.emptyTitle': 'За 14 дней предупреждений не было',
  'alerts.feed.emptyText':
    'Сюда приходят предупреждения о сроках заготовок точки — по порогам ленты точки. Лента хранит их 14 дней.',
  'alerts.feed.loadFailed': 'Лента не загрузилась. Проверьте связь и попробуйте ещё раз.',
  'alerts.feed.offline': 'Нет сети — новые сообщения появятся, когда связь вернётся.',
  'alerts.feed.disabledTitle': 'Лента появится после обновления сервера',
  'alerts.feed.disabledText': 'Предупреждения по-прежнему приходят в Telegram и push на телефон.',
  'alerts.summary.many': 'Новых предупреждений: {count}',
  'alerts.device.section': 'Уведомления Windows',
  'alerts.device.toggle': 'Показывать предупреждения на этом устройстве',
  'alerts.device.hint':
    'Всплывают в углу экрана и остаются в центре уведомлений Windows — для всех, кто работает на этом устройстве, и после пересменки.',
  'alerts.device.help':
    'Не приходят — проверьте в параметрах Windows, что уведомления Рестомаркера включены, а «Фокусировка внимания» выключена.',
  'alerts.device.needsUpdate':
    'Нужна новая версия приложения для Windows — её ставят один раз на каждое устройство с Windows.',
  'alerts.device.denied':
    'Windows не разрешает уведомления Рестомаркеру. Разрешите их: Параметры → Система → Уведомления.',
  'alerts.device.test': 'Проверить уведомление',
  'alerts.device.tested':
    'Пробное уведомление отправлено — оно должно всплыть в углу экрана. Не видно — проверьте в параметрах Windows уведомления Рестомаркера и «Фокусировку внимания».',
  'alerts.device.testTitle': 'Рестомаркер: проверка уведомлений',
  'alerts.device.testBody': 'Уведомления Windows работают — предупреждения о сроках придут сюда.',
  'alerts.nudge.title': 'Уведомления Windows на этом устройстве выключены',
  'alerts.nudge.hint':
    'Включите — и предупреждения о сроках будут всплывать в углу экрана, даже когда окно свёрнуто.',
  'alerts.nudge.turnOn': 'Включить',
  'alerts.nudge.hide': 'Не нужно',
  'alerts.location.section': 'Лента точки «{name}»',
  'alerts.location.hint':
    'Что попадает в ленту точки и всплывает на устройствах, где включены уведомления Windows. Одно на всю смену.',
  'alerts.location.readOnly':
    'Лента и уведомления на устройствах точки: {tiers}. Меняют менеджер точки и владелец сети.',
  'alerts.location.half': 'за половину срока',
  'alerts.location.lead': 'за {label}',
  'alerts.location.untilEnd': 'до конца',
  'alerts.location.and': 'и',

  // --- Общее ---------------------------------------------------------------
  'common.save': 'Сохранить',
  'common.cancel': 'Отмена',
  'common.edit': 'Изменить',
  'common.delete': 'Удалить',
  'common.actions': 'Действия',
  'common.ok': 'Понятно',
  'common.close': 'Закрыть',
  'common.loading': 'Загрузка…',
  'common.refresh': 'Обновить',
  'common.pullToRefresh': 'Потяните, чтобы обновить',
  'common.releaseToRefresh': 'Отпустите, чтобы обновить',
  'common.refreshing': 'Обновляем…',
  'common.retry': 'Повторить',

  // --- Ошибки --------------------------------------------------------------
  // Формулировки без «упс» и без технических кодов: человек на кухне должен
  // понять, что делать дальше, а не что сломалось внутри.
  'catalog.error.http': 'Сервер отклонил запрос. Проверьте данные и попробуйте снова.',
  'catalog.error.network': 'Нет связи с сервером. Проверьте сеть.',
  'catalog.error.unknown': 'Не удалось выполнить действие.',

  // --- Единицы срока -------------------------------------------------------
  'catalog.unit.hours': 'Часы',
  'catalog.unit.days': 'Дни',
  'catalog.unit.months': 'Месяцы',
  'catalog.status.active': 'Активные',
  'catalog.status.archived': 'Архив',

  // --- Фильтры -------------------------------------------------------------
  'filters.toggle': 'Фильтры',
  'catalog.filter.search': 'Поиск',
  'catalog.filter.searchPlaceholder': 'Название продукта',
  'catalog.filter.type': 'Тип продукта',
  'catalog.filter.allTypes': 'Все типы',
  'catalog.filter.status': 'Статус',
  'catalog.filter.allActive': 'Все активные',

  // --- Категории сроков ----------------------------------------------------
  'catalog.category.pageTitle': 'Категории сроков',
  'catalog.category.subtitle':
    'Категория задаёт точный срок годности. Из неё считается дата на этикетке.',
  'catalog.category.subtitleManager':
    'Справочник ведёт админ сети. Срок продукту на своей точке вы выбираете в меню точки.',
  'catalog.category.create': 'Новая категория',
  'catalog.category.edit': 'Изменение категории',
  'catalog.category.name': 'Название',
  'catalog.category.unit': 'Единица срока',
  'catalog.category.unitHint': 'Месяцы считаются календарно, а не как 30 дней.',
  'catalog.category.value': 'Длительность',
  'catalog.category.color': 'Цвет',
  'catalog.category.shelfLife': 'Срок',
  'catalog.category.band': 'Полка',
  'catalog.category.usage': 'Используется',
  'catalog.category.global': 'Глобальная',
  'catalog.category.readOnly': 'Только чтение',
  'catalog.category.editWarning':
    'Категория уже используется. Новый срок применится к будущим этикеткам; напечатанные ранее не пересчитываются.',
  'catalog.category.deleteTitle': 'Удалить категорию?',
  'catalog.category.deleteDescription':
    'Удалить можно только категорию, которой не пользуется ни один продукт.',
  'catalog.category.emptyTitle': 'Категорий пока нет',
  'catalog.category.emptyDescription':
    'Категория — это точная длительность срока: 48 часов, 5 дней, 6 месяцев.',

  // --- Родительский каталог ------------------------------------------------
  'catalog.master.pageTitle': 'Родительский каталог',
  'catalog.master.noPushNotice':
    'Изменения здесь не применяются к точкам, где продукт уже есть: их меню живут отдельно.',
  'catalog.master.create': 'Новый продукт',
  'catalog.master.edit': 'Изменение продукта',
  'catalog.master.name': 'Наименование',
  'catalog.master.category': 'Категория срока',
  'catalog.master.categoryPlaceholder': 'Выберите категорию',
  'catalog.master.categoryHint': 'Станет сроком по умолчанию для копий на точках.',
  'catalog.master.type': 'Тип продукта',
  'catalog.master.typePlaceholder': 'Не выбран',
  'catalog.master.typeHint': 'Только для фильтров. На срок и этикетку не влияет.',
  'catalog.master.storage': 'Условия хранения',
  'catalog.master.storageHint': 'Печатается на этикетке. Например: +2…+6 °C.',
  'catalog.master.sku': 'Артикул',
  'catalog.master.global': 'СанПиН',
  'catalog.master.readOnly': 'Только чтение',
  'catalog.master.usedInLocations': 'Точек',
  'catalog.master.deleteTitle': 'Удалить продукт из каталога?',
  'catalog.master.deleteDescription':
    'Копии на точках останутся и продолжат печататься, но потеряют связь с каталогом.',
  'catalog.master.deleteAffects': 'Затронуто точек',
  'catalog.master.deletedTitle': 'Продукт удалён',
  'catalog.master.detachedCopies': 'Копий стало локальными',
  'catalog.master.emptyTitle': 'Каталог пуст',
  'catalog.master.emptyDescription':
    'Добавьте продукты сети — они станут основой меню для новых точек.',

  // --- Меню точки ----------------------------------------------------------
  'catalog.product.storageFrom': 'от',
  'catalog.product.storageTo': 'до',
  'catalog.product.storagePlaceholder': 'Например: в сухом месте',
  'catalog.product.storageAsRange': 'Задать температурой',
  'catalog.product.storagePreview': 'На этикетке: {value}',
  'catalog.product.storageEmpty': 'Не указано — на этикетку ничего не уйдёт.',
  'catalog.product.search': 'Поиск по названию',
  'catalog.product.searchPlaceholder': 'Например: тесто',
  'catalog.product.pageTitle': 'Меню точки',
  'catalog.product.subtitle': 'По этому списку печатают этикетки.',
  'catalog.product.create': 'Новый продукт',
  'catalog.product.edit': 'Изменение продукта',
  'catalog.product.name': 'Наименование',
  'catalog.product.category': 'Категория срока',
  'catalog.product.categoryPlaceholder': 'Выберите категорию',
  'catalog.product.categoryHint': 'Здесь уточняется срок продукта на вашей точке.',
  'catalog.product.type': 'Тип продукта',
  'catalog.product.typePlaceholder': 'Не выбран',
  'catalog.product.storage': 'Условия хранения',
  'catalog.product.storageHint': 'Печатается на этикетке.',
  'catalog.product.sku': 'Артикул',
  'catalog.product.source': 'Источник',
  'catalog.product.sourceAll': 'Все',
  'catalog.product.sourceCatalog': 'Из каталога',
  'catalog.product.sourceLocal': 'Локальный',
  'catalog.product.local': 'Локальный',
  'catalog.product.localHint': 'Продукт заведён на точке и не связан с каталогом сети.',
  'catalog.product.modified': 'Изменён',
  'catalog.product.modifiedHint': 'Отличается от продукта в родительском каталоге.',
  'catalog.product.editFromCatalogNotice':
    'Продукт пришёл из каталога сети. Правки останутся на вашей точке.',
  'catalog.product.addFromCatalog': 'Добавить из каталога',
  'catalog.product.deleteTitle': 'Убрать продукт из меню точки?',
  'catalog.product.deleteDescription':
    'Продукт уйдёт из активного меню — печатать по нему станет нельзя. Уже напечатанные ' +
    'этикетки в журнале и мониторинге не тронет: это архивация, а не удаление истории.',
  'catalog.product.emptyTitle': 'В меню точки пусто',
  'catalog.product.emptyDescription':
    'Добавьте продукты из каталога сети или заведите свои — печатать можно только то, что есть в меню.',

  // --- Добавление из каталога ----------------------------------------------
  'catalog.addFromCatalog.title': 'Добавить из каталога',
  'catalog.addFromCatalog.description':
    'Отметьте продукты. Уже добавленные будут пропущены — повторов не появится.',
  'catalog.addFromCatalog.already': 'уже в меню',
  'catalog.addFromCatalog.submit': 'Добавить',
  'catalog.addFromCatalog.doneTitle': 'Готово',
  'catalog.addFromCatalog.added': 'Добавлено',
  'catalog.addFromCatalog.restored': 'Возвращено в меню',
  'catalog.addFromCatalog.skipped': 'Пропущено (уже в меню)',
  'catalog.addFromCatalog.unavailable': 'Недоступно',
  'catalog.addFromCatalog.emptyTitle': 'Ничего не найдено',
  'catalog.addFromCatalog.emptyDescription': 'Измените запрос или добавьте продукт в каталог сети.',
  'catalog.addFromCatalog.new': 'Новое',
  'catalog.addFromCatalog.removed': 'убрано из меню',

  // --- Новое в каталоге сети (T-045) ----------------------------------------
  // Число окна «новизны» в тексты не вшито: константа живёт на сервере
  // (`CATALOG_NEW_ITEMS_WINDOW`), и её правка не должна требовать нового бандла.
  'catalog.news.title': 'Новое в каталоге сети',
  'catalog.news.hint': 'Сеть недавно добавила эти позиции, а в меню точки их нет',
  'catalog.news.add': 'Добавить в меню',
  'catalog.news.addAll': 'Добавить все',
  'catalog.news.showAll': 'Показать все',
  'catalog.news.collapse': 'Свернуть',
  'catalog.news.added': 'Добавлено в меню',
  'catalog.news.alreadyInMenu': 'Уже в меню',
  'catalog.news.queued': 'Нет сети — позиции добавятся, когда связь вернётся',
  'catalog.news.loadError': 'Не удалось загрузить новые позиции каталога',
} as const;

export type MessageKey = keyof typeof ru;
